// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2_JG8","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__20lcr"};